<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-card-title class="headline">
                        Reporte de Prospectos WhatsApp
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="fetchReport" class="mr-2">
                            <v-icon left>mdi-refresh</v-icon>
                            Actualizar
                        </v-btn>
                        <v-btn color="success" @click="downloadJson" :disabled="report.length === 0">
                            <v-icon left>mdi-download</v-icon>
                            Descargar JSON
                        </v-btn>
                    </v-card-title>

                    <v-card-text>
                        <v-row class="mb-4">
                            <v-col cols="12" md="4">
                                <v-select v-model="filtroEtq" :items="etqFiltro" item-text="label" item-value="value"
                                    label="Filtrar por etiqueta" outlined clearable></v-select>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field v-model="buscar" label="Buscar" outlined prepend-inner-icon="mdi-magnify"
                                    clearable></v-text-field>
                            </v-col>
                        </v-row>
                        <v-data-table :search="buscar" :headers="headers" :items="registrosFiltrados"
                            :items-per-page="10" class="elevation-1" @click:row="openConversationModal">
                            <template v-slot:item.twilio_tipo="{ item }">
                                <v-chip small
                                    :color="item.twilio_tipo === 'COMPLETO' ? 'green' : item.twilio_tipo === 'INCOMPLETO' ? 'orange' : 'grey'"
                                    text-color="white">
                                    {{ item.twilio_tipo }}
                                </v-chip>
                            </template>

                            <template v-slot:item.etiqueta_actual="{ item }">
                                <v-chip small color="primary" v-if="item.etiqueta_actual !== null">
                                    {{ item.etiqueta_actual }}
                                </v-chip>
                                <span v-else class="grey--text">Sin etiqueta</span>
                            </template>

                            <template v-slot:item.mensaje_inicial="{ item }">
                                <div class="text-truncate" style="max-width: 300px;">
                                    {{ item.mensaje_inicial || 'Sin mensaje de texto inicial (posible media)' }}
                                </div>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!-- Modal de Conversación -->
        <v-dialog v-model="modalOpen" max-width="800" scrollable>
            <v-card v-if="selectedItem">
                <v-card-title class="headline">
                    Conversación - {{ selectedItem.numero_telefono }}
                    <v-spacer></v-spacer>
                    <v-btn icon @click="modalOpen = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="pt-4">
                    <div v-for="day in selectedItem.conversacion" :key="day.date" class="mb-6">
                        <div class="text-subtitle-1 font-weight-bold mb-3">
                            {{ formatDate(day.date) }}
                        </div>

                        <div v-for="msg in day.messages" :key="msg.time" class="mb-3">
                            <div class="d-flex" :class="{
                                'flex-row-reverse': msg.mio === 1,
                                'flex-row': msg.mio !== 1
                            }">
                                <v-sheet :color="msg.mio === 1 ? 'green lighten-1' : 'blue-grey lighten-4'"
                                    class="pa-3 rounded-lg" max-width="70%">
                                    <div class="white--text" v-if="msg.mio === 1">
                                        <strong>Vendedora:</strong> {{ msg.time }}
                                    </div>
                                    <div class="black--text" v-else>
                                        <strong>Cliente:</strong> {{ msg.time }}
                                    </div>

                                    <div class="mt-1">
                                        <span v-if="msg.message && msg.message.trim() !== ''">
                                            {{ msg.message }}
                                        </span>
                                        <em v-else class="white--text">
                                            Mensaje sin texto (imagen, audio o documento)
                                        </em>
                                    </div>
                                </v-sheet>
                            </div>
                        </div>
                    </div>

                    <div v-if="selectedItem.conversacion.length === 0" class="text-center grey--text">
                        No hay mensajes en el período seleccionado.
                    </div>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="modalOpen = false">
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <carga v-if="cargar" />
    </v-container>
</template>

<script>
import carga from "@/components/alertas/carga.vue";
export default {
    name: 'ReporteProspectos',
    components: {
        carga,
    },
    data() {
        return {
            cargar: false,
            buscar: "",
            filtroEtq: null,
            etqFiltro: [
                { value: 1, label: 'PENDIENTE DE PAGO', color: '#F44336' },
                { value: 2, label: 'CLIENTE POTENCIAL', color: '#29B6F6' },
                { value: 3, label: 'EXAMEN REALIZADO', color: '#FF9800' },
                { value: 4, label: 'PAGO PARCIAL', color: '#D4AF37' },
                { value: 5, label: 'INSCRITO', color: '#4CAF50' },
                { value: 6, label: 'VENTANA DE TIEMPO', color: '#4A148C' },
                { value: 7, label: 'SPAM', color: '#000000' },
                { value: 8, label: 'CON CITA AGENDADA', color: '#9C27B0' },
                { value: 9, label: 'CLIENTE NO CONTESTA', color: '#B0BEC5' },
                { value: 10, label: 'NO INTERESADO', color: '#546E7A' },
                { value: 11, label: 'EXAMEN ENVIADO', color: '#FFEB3B' },
                { value: 12, label: 'NUEVO', color: '#E040FB' },
                { value: 13, label: 'PRIMER CONTACTO', color: '#00BCD4' },
                { value: 14, label: 'LLAMADA AGENDADA', color: '#3F51B5' }
            ],
            idSchool: 1,
            report: [], // Se llena desde la API
            modalOpen: false,
            selectedItem: null,

            headers: [
                { text: 'Teléfono', value: 'numero_telefono', width: '130' },
                { text: 'Folio', value: 'folio', width: '120' },
                { text: 'Twilio Pertenece', value: 'twilio_pertenece', width: '140' },
                { text: 'Tipo Twilio', value: 'twilio_tipo', width: '120' },
                { text: 'Mensaje Inicial', value: 'mensaje_inicial' },
                { text: 'Vendedora', value: 'vendedora_asignada', width: '180' },
                { text: 'Sucursal', value: 'sucursal_asignada', width: '160' },
                { text: 'Etiqueta Actual', value: 'etiqueta_actual', align: 'center', width: '130' },
            ],
        };
    },
    computed: {
        registrosFiltrados() {
            let filtradas = this.report

            if (this.filtroEtq) {
                filtradas = filtradas.filter(a => a.id_etiqueta_actual === this.filtroEtq)
            }

            return filtradas
        },
    },
    created() {
        this.defineIdSchool()
    },
    mounted() {
        this.fetchReport();
    },
    methods: {
        defineIdSchool() {
            this.idSchool = this.$route.name == "reporteMensajes" ? 1 : 2
        },
        async fetchReport() {
            this.cargar = true
            try {
                const response = await this.$http.get('/api/generarReporte/mensajes/' + this.idSchool);

                this.report = response.data.report || [];
                console.log(this.report.filter(it => it.etiqueta_actual == 'INSCRITO').length);

                this.cargar = false
            } catch (error) {
                this.cargar = false
                console.error('Error cargando reporte:', error);
                this.$toast.error('Error al cargar el reporte');
            }
        },

        openConversationModal(item) {
            this.selectedItem = item;
            this.modalOpen = true;
        },

        formatDate(dateStr) {
            const options = { year: 'numeric', month: 'long', day: 'numeric' };
            return new Date(dateStr).toLocaleDateString('es-MX', options);
        },

        downloadJson() {
            if (this.report.length === 0) return;

            const dataStr = JSON.stringify(this.report, null, 2);
            const dataUri = 'data:application/json;charset=utf-8,' + encodeURIComponent(dataStr);

            const exportFileDefaultName = `reporte_prospectos_escuela_${this.$route.query.escuela || 1}_${new Date().toISOString().slice(0, 10)}.json`;

            const linkElement = document.createElement('a');
            linkElement.setAttribute('href', dataUri);
            linkElement.setAttribute('download', exportFileDefaultName);
            linkElement.click();
        },
    },
};
</script>

<style scoped>
.text-truncate {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>